import { appConfig } from '../config'

// account urls
export const account = () => '/account'
export const organizationSettings = () => '/organization-settings'
export const login = () => '/login'

export const templatesList = () => '/templates'
export const apiKeysList = () => '/apikeys'
export const memory = () => '/memory'

export const playground = () => '/playground'

// Agent Builder
export const chatbotAgentsList = () => '/teammates'
export const chatbotAgentsListTab = (tab: string) => `/teammates?tab=${tab}`
export const chatbotAgentsNew = () => '/teammates/new'
export const chatbotAgent = (agentId: string) => `/teammates/${agentId}`

// User Tools
export const userToolsList = () => '/user-tools'
export const userToolNew = () => '/user-tools/new'
export const userTool = (userToolId: string) => `/user-tools/${userToolId}`

// Skills
export const skillsList = () => '/skills'
export const skillNew = () => '/skills/new'
export const skill = (skillId: string) => `/skills/${skillId}`

// Helpers
export const agentsList = chatbotAgentsList
export const agentsNew = () => `${chatbotAgentsList()}/new`

export const agentCanvas = (agentId: string) => `${chatbotAgentsList()}/${agentId}`
export const agentDialog = (agentId: string) => `${chatbotAgentsList()}/${agentId}/dialog`

// Help & Support
export const userGuide = () => `${appConfig.helpBaseUrl}${appConfig.helpArticles.userGuide}`
export const howToVideos = () => `${appConfig.helpBaseUrl}${appConfig.helpArticles.howToVideos}`
export const support = () => `mailto:${appConfig.supportEmail}`

// torqagent chatflow urls
export const torqAgentChatflow = (chatflowId: string) => `/my-teammates/${chatflowId}`

// Team
export const teams = () => '/teams'
export const teamsSharedMarketplace = () => '/teams/shared-teams'
export const teamsNew = () => '/teams/new'
export const teamsBuild = (teamId: string) => `/teams/${teamId}/build`
export const teamsRunLatest = (teamId: string) => `/teams/${teamId}/run`
export const teamsRunById = (teamId: string, runId: string) => `/teams/${teamId}/runs/${runId}`
export const teamsHistory = (teamId: string) => `/teams/${teamId}/history`
export const teamsSchedules = (teamId: string) => `/teams/${teamId}/schedule`
